


















































import Component from 'vue-class-component'
import { Vue, Watch } from 'vue-property-decorator'

interface Answer {
  age: string;
  sex: string;
  shampooName: string;
}

@Component
export default class PersonalQuestion extends Vue {
  public ready = false
  public value = {
    age: '',
    sex: '',
    shampooName: ''
  }

  public questions = [
    {
      choices: [
        '男',
        '女'
      ],
      answer: '',
      id: 'sex',
      label: '性別'
    },
    {
      choices: [
        '20~24歳',
        '25~29歳',
        '30~34歳',
        '35~39歳',
        '40~44歳',
        '45~49歳',
        '50~54歳',
        '55~59歳',
        '60~64歳',
        '65歳~'
      ],
      answer: '',
      id: 'age',
      label: '年齢'
    }
  ]

  created () {
    window.scrollTo({
      top: 0
    })
  }

  @Watch('value', { deep: true })
  public onValueChanged (val: any) {
    if (val.sex !== '' && val.age !== '') {
      this.ready = true
    }
  }

  @Watch('questions', { deep: true })
  public onConditionPainValueChanged (newValue: any, oldValue: any) {
    if (newValue[0].answer !== this.value.sex) {
      this.value.sex = newValue[0].answer
    }
    if (newValue[1].answer !== this.value.age) {
      this.value.age = newValue[1].answer
    }
  }

  public setValue () {
    this.$emit('handle-parent', this.value)
  }
}
